/* ══════════════════════════════════════════════════════════════════════════
 * CLS-SE school shop — what the customer-facing shop looks like.
 * Shared by SchoolShop and the CreateShop review preview so the preview can
 * never drift from the real shop (banner photos, FOMO copy, card labels).
 * ══════════════════════════════════════════════════════════════════════════ */
import bannerDesktop from '../../../../assets/cls-se/school-shop/Skolmerch-Desktop.jpg';
import bannerMobile from '../../../../assets/cls-se/school-shop/Skolmerch-Mobile.jpg';

// SecondaryBanner photos — Skolmerch for every shop until Overalls & More gets its own.
// Static fallback behind the brand's uploaded per-menu-item header photos.
export const SKOLMERCH_BANNER = { backgroundImage: bannerDesktop, backgroundImageMobile: bannerMobile };

// No Trustpilot on the CLS-SE school shop banner (yet).
export const BANNER_TRUSTPILOT = null;

// FomoBlock copy: live countdown, or the fixed close date ("date" display mode).
export const FOMO_COUNTDOWN_TEMPLATE = 'Skynda! Webbshoppen stänger om {time}';
export const FOMO_DATE_TEMPLATE = 'Webbshoppen stänger {time}';
export const FOMO_UNITS = { day: 'd', hour: 't', minute: 'm' };

// ProductCard copy.
export const PACKAGE_DESCRIPTION = 'Paketlösning';
export const MORE_LABEL = 'fler';
